namespace Nobox.CRM {
    export interface TaskKanbanResponse {
        ArrHeader?: TaskboardlistRow[];
        ArrItem?: TaskRow[];
    }
}
